export const search = {
  searchType: "Τύπος Αναζήτησης",
  searchByKeyword: "Αναζήτηση με λέξη-κλειδί",
  searchByCategory: "Αναζήτηση ανά κατηγορία",
  typeHere: "Πληκτρολογήστε εδώ",
};
